import exact from 'prop-types-exact';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import Button from '../Atoms/Button';

const propTypes = exact({
  buttonText: PropTypes.string,
  disclaimerText: PropTypes.string,
});

const defaultProps = {
  buttonText: 'Accept',
  disclaimerText: 'This site uses cookies.',
};

class CookiesNotice extends React.Component {
  constructor(props) {
    super(props);

    this.handleButtonClick = this.handleButtonClick.bind(this);

    this.state = {
      sessionAccepted: false,
      cookiesAccepted: window.localStorage.getItem('cookiesAccepted'),
    };
  }

  handleButtonClick() {
    window.localStorage.setItem('cookiesAccepted', true);
    this.setState({ sessionAccepted: true });
  }

  render() {
    if (this.state.cookiesAccepted) return null;

    const containerClasses = classnames('CookiesNotice', { hide: this.state.sessionAccepted });

    return (
      <div className={containerClasses}>
        <div className="CookiesNotice_container">
          <div
            className="CookiesNotice_disclaimer"
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML={{ __html: this.props.disclaimerText }}
          />
          <div className="CookiesNotice_action">
            <Button
              blockName="CookiesNotice_button"
              buttonType="button"
              handleClick={this.handleButtonClick}
              modifier="ghost"
              text={this.props.buttonText}
            />
          </div>
        </div>
      </div>
    );
  }
}

CookiesNotice.propTypes = propTypes;
CookiesNotice.defaultProps = defaultProps;

export default CookiesNotice;
